import { IBlackUser } from "../../../../store/types/userTypes";

// Confirmado con backend: "denyAccess" = "Restricción total de acceso".
// Cualquier otro valor (incluido "" = "Alerta al guardia", o ausente) se
// trata como alerta permisiva.
export const FULL_ACCESS_RESTRICTION_VALUE = "denyAccess";

export const isFullAccessRestriction = (
  blacklistedData: IBlackUser | null | undefined
): boolean => blacklistedData?.restrictionType === FULL_ACCESS_RESTRICTION_VALUE;
